export default {
  awaitWrap(promise) {
    return promise.then(data => [null, data]).catch(error => [error, null]);
  },
};

